<template>

  <label class="container">
    <span class="icon"
          :data-balloon="'Select this project'"
          data-balloon-pos="down-left">
      <input type="checkbox"
             :checked="checked"
             :value="projectID"
             @click.stop="selected">
      <span class="checkmark"></span>
    </span>
  </label>
</template>

<script>
import auth from '@/mixins/auth'
export default {
  props: ['projectID'],
  mixins: [auth],
  data: function () {
    return {
      checked: false
    }
  },
  methods: {
    selected: function (e) {
      this.checked = e.target.checked
      this.$store.dispatch('selectSpamProject', { id: this.projectID, selected: this.checked })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.container {
  display: block;
  position: absolute;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 5

}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 7px;
  left: 8px;
  height: 25px;
  width: 25px;
  background-color: #fff;
  border: 2px solid $primary;
  border-radius: 15px;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 7.5px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid $primary;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

::v-deep .icon {
  width: 2.5rem;
  height: 2rem;
  position: absolute;
  left: 3px;
  top: 3px;
}
</style>
